import { render } from "./RestrictionTerms.vue?vue&type=template&id=3dccbf46"
import script from "./RestrictionTerms.vue?vue&type=script&lang=js"
export * from "./RestrictionTerms.vue?vue&type=script&lang=js"

import "./RestrictionTerms.vue?vue&type=style&index=0&id=3dccbf46&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__